module.exports = __webpack_public_path__ + "images/dummy-portfolio-5ddd222e79c1d1dcc03dc531a30782ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/dummy-portfolio.jpg
// module id = 11
// module chunks = 0